import request from '@/utils/request'

//获取信息核对进度
export function getFeedbackProcess(query) {
  return request({
    url: '/bff-dp-mobile/all-channel-data/data/process',
    method: 'get',
    params: query
  })
}

//查询分销商信息
export function getDistributor(query) {
  return request({
    url: '/bff-dp-mobile/all-channel-data/distributor-list',
    method: 'get',
    params: query
  })
}

//新增分销商
export function addDistributor(data) {
  return request({
    url: '/bff-dp-mobile/all-channel-data/distributor',
    method: 'post',
    data: data
  })
}

//编辑分销商
export function editDistributor(data) {
  return request({
    url: '/bff-dp-mobile/all-channel-data/distributor',
    method: 'put',
    data: data
  })
}

//删除分销商
export function deleteDistributor(data) {
  return request({
    url: '/bff-dp-mobile/all-channel-data/distributor/' + data.id,
    method: 'delete'
  })
}

//删除全渠道链数据
export function deleteChainData(data) {
  return request({
    url: '/bff-dp-mobile/all-channel-data/delete-data',
    method: 'post',
    data: data
  })
}

//更新全渠道链数据状态
export function editChainData(data) {
  return request({
    url: '/bff-dp-mobile/all-channel-data/update-status',
    method: 'put',
    data: data
  })
}

//批量提交全渠道链数据
export function submitChainData(data) {
  return request({
    url: '/dealer/all-channel-data/batch-confirm',
    method: 'put',
    data: data
  })
}

//新增全渠道链数据
export function addChainData(data) {
  return request({
    url: '/dealer/all-channel-data/add-data',
    method: 'post',
    data: data
  })
}


//新增分销商-新
export function addDistributorInfo(data) {
  return request({
    url: '/dealer/distributor/info',
    method: 'post',
    data: data
  })
}

// 更新 put /bff-web/distributor/info/' + data.distributorId,
export function editDistributorInfo(data) {
  return request({
    url: '/dealer/distributor/info/' + data.distributorInfoId,
    method: 'put',
    data: data
  })
}

// "name": "删除",
// 						"raw": "{{baseUrl}}/distributor/info/1",
export function deleteDistributorInfo(data) {
  return request({
    url: '/dealer/distributor/info/' + data.distributorInfoId,
    method: 'delete',
    data: data
  })
}

//查询分销商下的所有经销商
export function getDealerList(query) {
  return request({
    url: '/dealer/distributor/info/dealer/list',
    method: 'get',
    params: query
  })
}

//检查是否有未备案的分销商
export function checkUnregisteredDistributors() {
  return request({
    url: '/dealer/distributor/info/add/list',
    method: 'get'
  })
}

// 查询核对详情
export function getCheckDetail(id) {
  return request({
    url: '/dealer/all-channel-data/list?channelId=' + id,
    method: 'get'
  })
}
